import { Set } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { ConspirateursMoveDrop, ConspirateursMoveJump, ConspirateursMoveSimple } from './ConspirateursMove';
import { ConspirateursRules } from './ConspirateursRules';
import { ConspirateursState } from './ConspirateursState';
export class ConspirateursMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        if (node.gameState.turn < ConspirateursRules.NUMBER_OF_PIECES) {
            return this.getListMovesDrop(node.gameState);
        }
        else {
            return this.getListMovesAfterDrop(node.gameState);
        }
    }
    getListMovesDrop(state) {
        const moves = [];
        const start = ConspirateursState.CENTRAL_ZONE_TOP_LEFT;
        const end = ConspirateursState.CENTRAL_ZONE_BOTTOM_RIGHT;
        for (let y = start.y; y <= end.y; y++) {
            for (let x = start.x; x <= end.x; x++) {
                if (state.getPieceAtXY(x, y).isNone()) {
                    moves.push(ConspirateursMoveDrop.of(new Coord(x, y)));
                }
            }
        }
        return moves;
    }
    getListMovesAfterDrop(state) {
        let moves = [];
        const currentPlayer = state.getCurrentPlayer();
        for (const coordAndContent of state.getCoordsAndContents()) {
            if (coordAndContent.content === currentPlayer) {
                moves = moves.concat(this.getListSimpleMoves(state, coordAndContent.coord));
                moves = moves.concat(this.getListJumps(state, coordAndContent.coord));
            }
        }
        return moves;
    }
    getListSimpleMoves(state, coord) {
        const moves = [];
        const targets = [
            new Coord(coord.x + 1, coord.y),
            new Coord(coord.x - 1, coord.y),
            new Coord(coord.x, coord.y + 1),
            new Coord(coord.x, coord.y - 1),
            new Coord(coord.x + 1, coord.y + 1),
            new Coord(coord.x + 1, coord.y - 1),
            new Coord(coord.x - 1, coord.y + 1),
            new Coord(coord.x - 1, coord.y - 1),
        ].filter((c) => state.isOnBoard(c));
        for (const target of targets) {
            const move = ConspirateursMoveSimple.from(coord, target);
            if (move.isSuccess() && ConspirateursRules.get().simpleMoveLegality(move.get(), state).isSuccess()) {
                moves.push(move.get());
            }
        }
        return moves;
    }
    getListJumps(state, start) {
        let moves = new Set();
        for (const firstTarget of ConspirateursRules.get().jumpTargetsFrom(state, start)) {
            const jump = ConspirateursMoveJump.from([start, firstTarget]).get();
            if (ConspirateursRules.get().jumpLegality(jump, state).isSuccess()) {
                moves = moves.addElement(jump);
                moves = moves.union(this.getListJumpStartingFrom(state, jump));
            }
        }
        return moves.toList();
    }
    getListJumpStartingFrom(state, jump) {
        const nextJumps = ConspirateursRules.get().nextJumps(jump, state);
        let jumps = new Set(nextJumps);
        for (const nextJump of nextJumps) {
            jumps = jumps.union(this.getListJumpStartingFrom(state, nextJump));
        }
        return jumps;
    }
}
